import { useSpring, animated as a } from "@react-spring/web";
import { Html, useTexture } from "@react-three/drei";
import { useEbbne } from "@solidwhite/ebbnen";
import { Suspense, useEffect, useState } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useHashLocation from "../../../../../use-hash-location";
import { findObjectStartsWithKey } from "../../../../../utils/FindObjects";
import images from "./images/images";
import store from "../../../../../appStore";
import { SideBarHider } from "../../../../ui/SideBar/SideBar";

const clickPositions = [
  {
    x: 524,
    y: 704,
  },
  {
    x: 365,
    y: 142,
  },
  {
    x: 417,
    y: 240,
  },
  {
    x: 575,
    y: 142,
  },
  {
    x: 790,
    y: 142,
  },
  {
    x: 160,
    y: 1120,
  },
];

const ClickTarget = ({ position, onClick, ...props }) => {
  const pulse = useSpring({
    loop: true,
    config: {
      duration: 1800,
    },
    from: {
      scale: 0.4,
      opacity: 0.75,
    },
    to: {
      scale: 1.75,
      opacity: 0,
    },
  });

  const pulseInner = useSpring({
    loop: true,
    config: {
      duration: 1800,
    },
    from: {
      border: "6px solid #ff8800",
    },
    to: {
      border: "6px solid #ffb968",
    },
  });

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        transform: `translate(${position.x}px,${position.y}px)`,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          transform: "translate(-50%,-50%)",
          width: "200px",
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <a.div
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "150px",
            border: "2px solid #ffd3a1",
            ...pulse,
          }}
        ></a.div>
      </div>
      <a.div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          transform: "translate(-50%,-50%)",
          width: "60px",
          height: "60px",
          // backgroundColor: "red",
          borderRadius: "60px",
          // border: "6px solid #ffb968",
          cursor: "pointer",
          pointerEvents: "auto",
          ...pulseInner,
        }}
        onClick={() => (onClick ? onClick() : () => {})}
      ></a.div>
    </div>
  );
};

const ControlPanel = ({ object3d, ...props }) => {
  const { active } = useEbbne();

  const { i18n } = useTranslation();

  const parent = useMemo(() => {
    return findObjectStartsWithKey("ScreenTarget", object3d);
  }, []);

  const [location, setLocation] = useHashLocation();

  const [currentSlide, setCurrentSlide] = useState(0);

  const textureSrc = useMemo(() => {
    return images[i18n.language] ? images[i18n.language][currentSlide] : images["de"][currentSlide];
  }, [currentSlide, i18n.language]);

  const handleButtonClick = () => {
    if (currentSlide < clickPositions.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      setLocation("/heat/products/hardline/process/vertical");
    }
  };

  return (
    active && (
      <group position={parent.position} rotation={parent.rotation} scale={0.0102}>
        <SideBarHider />

        <Suspense fallback={<FallbackPlane />}>
          <DisplayPlane textureSrc={textureSrc} />
        </Suspense>

        <Html transform occlude zIndexRange={[0, 1]} style={{ pointerEvents: "none" }}>
          <div
            style={{
              width: "1366px",
              height: "768px",
              pointerEvents: "none",
            }}
          >
            {/* <img
              src={
                images[i18n.language]
                  ? images[i18n.language][currentSlide]
                  : images["de"][currentSlide]
              }
              style={{
                width: "100%",
                height: "100%",
                opacity: 0,
              }}
            /> */}
            <ClickTarget position={clickPositions[currentSlide]} onClick={handleButtonClick} />
          </div>
        </Html>
      </group>
    )
  );
};

const DisplayPlane = ({ textureSrc, ...props }) => {
  const texture = useTexture(textureSrc);

  return (
    <mesh scale={0.02495} position={[0, 0, 0.075]}>
      <planeGeometry args={[1366, 768]} />
      <meshStandardMaterial
        map={texture}
        toneMapped={false}
        color="#ffffff"
        // emissive="white"
      />
    </mesh>
  );
};

const FallbackPlane = ({}) => {
  return (
    <mesh scale={0.02495} position={[0, 0, 0.075]}>
      <planeGeometry args={[1366, 768]} />
      <meshStandardMaterial color="#000000" />
    </mesh>
  );
};

export default ControlPanel;
